<template>
  <div id="billing_current-plan" class="mb-8">
    <div class="card tile">
      <div class="card-header border-bottom rounded-0">
        <h3 class="card-text">
          {{ trans('dashboard.account.billing.subscriptions.title') }}
        </h3>
      </div>
      <div class="card-body">
        <p v-if="!subscriptions.length">
          {{ trans('dashboard.account.billing.subscriptions.no_subscriptions') }}</p>
        <ul v-else class="list-group">
          <li v-for="subscription in subscriptions" class="list-group-item flex-column align-items-start">
            <div class="d-flex w-100 justify-content-between align-items-center">
              <h6>{{ subscription.title }}</h6>
              <button v-if="canUpdate" type="submit" class="button btn-disabled">
                {{ trans('dashboard.account.billing.subscriptions.update_plan') }}
              </button>
            </div>
            <div class="row mt-3">
              <div class="col-md-4">{{ trans('dashboard.account.billing.subscriptions.payment') }}</div>
              <div class="col-md-8">
                <div>
                  <strong>{{ subscription.subtotal }}&nbsp;</strong>
                  <span>/ {{ trans(subscription.is_premium_yearly ? 'common.year' : 'common.month') }}</span>
                </div>
                <ul class="list-unstyled">
                  <li v-for="item in subscription.active_items">
                    <span>{{ `${item.description}: ${item.unit_amount} x ${item.quantity}` }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <template v-if="subscription.ends_at">
              <div class="row mt-2">
                <div class="col-md-4">{{ trans('dashboard.account.billing.subscriptions.ends_at') }}</div>
                <div class="col-md-8">
                  {{ trans('dashboard.account.billing.subscriptions.ends_at_x', {date: subscription.ends_at}) }}
                </div>
              </div>
              <div class="row mt-2 mb-2">
                <div class="col-md-12">
                  <inertia-link v-if="canUpdate"
                                :href="$route('dashboard.account.billing.subscriptions.resume', subscription.id)"
                                as="button"
                                method="post"
                                class="text-success text-sm">
                    {{ trans('dashboard.account.billing.subscriptions.resume_subscription') }}
                  </inertia-link>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="row mt-2">
                <div class="col-md-4">{{ trans('dashboard.account.billing.subscriptions.next_payment') }}</div>
                <div class="col-md-8" v-html="trans('dashboard.account.billing.subscriptions.next_payment_x', {date: subscription.cycle_ends_at})"/>
              </div>
              <div class="row mt-2 mb-2">
                <div class="col-md-12">
                  <inertia-link v-if="canUpdate"
                                :href="$route('dashboard.account.billing.subscriptions.cancel', subscription.id)"
                                as="button"
                                method="delete"
                                class="text-danger text-sm">
                    {{ trans('dashboard.account.billing.subscriptions.cancel_subscription') }}
                  </inertia-link>
                </div>
              </div>
            </template>
          </li>
        </ul>
      </div>
      <div class="card-footer">
        <p>
          * {{ trans('dashboard.account.billing.subscriptions.footnote') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BillingCurrentSubscriptions",

  props: {
    subscriptions: Array
  },
  computed: {
    canUpdate() {
      return this.$can('billings.update');
    }
  }
}
</script>
